'use client';

import type { ProductToCompareT } from '../../../../../../type/product/productComparison';
import type {
  ProductComparisonDrag,
  ProductComparisonDrop,
} from '@vs-shop/commerce-ui/productComparison';
import {
  ProductComparisonActionsCell as ActionsCell,
  ProductComparisonDragHandle,
  ProductComparisonRemove,
  ProductComparisonRemoveIcon,
  productComparisonDragIconVariants,
} from '@vs-shop/commerce-ui/productComparison';
import { Move, X } from 'lucide-react';
import { useIntl } from 'react-intl';

import { removeProductCodeAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  product: ProductToCompareT;
  drag: ProductComparisonDrag;
  drop: ProductComparisonDrop;
};

export default function ProductComparisonActionsCell({ product, drag, drop }: Props) {
  const intl = useIntl();
  const removeFromComparison = useAtomSet(removeProductCodeAtom);

  const handleRemoveProduct = () => {
    removeFromComparison(product.code);
  };

  return (
    <ActionsCell drop={drop}>
      <ProductComparisonDragHandle
        role="button"
        drag={drag}
        data-product-code={product.code}
        aria-label={intl.formatMessage(
          {
            id: 'productsComparisonHeaderColumnCellProduct.drag',
            defaultMessage: 'Přesunout {name}',
          },
          { name: product.name }
        )}
      >
        <Move className={productComparisonDragIconVariants({ drop })} />
      </ProductComparisonDragHandle>

      <ProductComparisonRemove
        onClick={handleRemoveProduct}
        data-product-code={product.code}
        aria-label={intl.formatMessage({
          id: 'productsComparisonHeaderColumnCellProduct.remove',
          defaultMessage: 'Odebrat z porovnání',
        })}
      >
        <ProductComparisonRemoveIcon render={<X />} />
      </ProductComparisonRemove>
    </ActionsCell>
  );
}
